import { render, staticRenderFns } from "./article_types_table.vue?vue&type=template&id=d02a355a&scoped=true"
import script from "./article_types_table.vue?vue&type=script&lang=ts"
export * from "./article_types_table.vue?vue&type=script&lang=ts"
import style0 from "./article_types_table.vue?vue&type=style&index=0&id=d02a355a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d02a355a",
  null
  
)

export default component.exports